export default __webpack_public_path__ + "static/media/sass_original_logo_icon_146350.8ec16938.svg";